import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TariffDetail } from '../models/tariff-detail.model';
import { Tariff } from '../models/tariff.model';
import { IFetchList, IFetchDetail } from '../../core/services/fetch-entity.interface';

@Injectable({
  providedIn: 'root'
})
export class TariffService implements IFetchList, IFetchDetail {
  apiUrl: string;
  apiCompanyUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.apiUrl = baseUrl + 'api/tariff';
    this.apiCompanyUrl = baseUrl + 'api/company/';
  }

  get(params: HttpParams) {
    return this.httpClient.get<Tariff[]>(this.apiUrl, { params: params, observe: 'response' });
  }

  getDetail(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.get<TariffDetail>(url);
  }

  getCompanyTarrif(companyId: number) {
    const url = this.apiCompanyUrl + String(companyId) + '/tarif';
    return this.httpClient.get<{}>(url);
  }

  create(tariff: Partial<TariffDetail>) {
    return this.httpClient.post(this.apiUrl, JSON.stringify(tariff), { headers: this.headers });
  }

  update(tariff: TariffDetail) {
    return this.httpClient.put(this.apiUrl, JSON.stringify(tariff), { headers: this.headers });
  }

  delete(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.delete(url);
  }
}
